import { render } from "./PartDetail.vue?vue&type=template&id=fcf524a8&scoped=true&bindings={}"
import script from "./PartDetail.vue?vue&type=script&lang=ts"
export * from "./PartDetail.vue?vue&type=script&lang=ts"

import "./PartDetail.vue?vue&type=style&index=0&id=fcf524a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fcf524a8"

export default script